// project import
import zIndex from "@mui/material/styles/zIndex"
import Navigation from "./Navigation"
import SimpleBar from "components/third-party/SimpleBar"

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => (
  <>
    <SimpleBar
      sx={{
        display: "inline-flex",
        flexDirection: "column",
        width: "100%",
        padding: "4px",
      }}
    >
      <Navigation />
    </SimpleBar>
  </>
)

export default DrawerContent
